import Lottie from 'lottie-react';
import React from 'react';
import styled from 'styled-components';

import lottie_loading from '../ui/LoadingLottie.json';

const MessageContainer = styled.div`
    display: flex;
    justify-content: 'flex-start';
    margin-bottom: 12px;
`;

const MessageBox = styled.div`
    max-width: 90%;
    padding: 10px 0 10px 14px;
    border-radius: 20px;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 15px;
    word-break: break-word;

    background-color: #f1f1f1;
    color: #000000;
    border-bottom-left-radius: 4px;
`;

const MessageLoading = () => {
    return (
        <MessageContainer>
            <MessageBox>
                <LottieLayout>
                    <Lottie loop={true} animationData={lottie_loading} />
                </LottieLayout>
            </MessageBox>
        </MessageContainer>
    );
};

const LottieLayout = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 30px;
`;

export default MessageLoading;
